import { Box, Theme, Typography } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import HeadingMarker from "../subcomponents/HeadingMarker";
import TeacherDetails from "../subcomponents/TeacherDetails";
import { gradientFadeStyle } from "./consts";

interface TeacherSectionProps {
  leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
  activity: ClassDetailsNoSectionsQuery["activity"];
  onClickViewReviews?: () => void;
  teacherHeaderRef: React.RefObject<HTMLElement>;
  credentialsRef: React.RefObject<HTMLElement>;
}

export default function TeacherSection({
  leader,
  activity,
  onClickViewReviews,
  teacherHeaderRef,
  credentialsRef,
}: TeacherSectionProps) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\sections\\TeacherSection",
  );

  return (
    <Box
      sx={(theme: Theme) => ({
        [theme.breakpoints.down("md")]: {
          display: "flex",
          flexDirection: "column",
          gap: "2.4rem",
        },
      })}
    >
      <Box>
        <Box ref={teacherHeaderRef}>
          <HeadingMarker />
        </Box>
        <Typography
          variant="h4"
          id="teacher"
          sx={{ fontWeight: 700, marginBottom: "1.6rem" }}
        >
          {activity.isClub
            ? t("Group Leader")
            : !!leader.ownerOfSellerOrg
            ? t("Offered by")
            : t("Meet the teacher")}
        </Typography>
      </Box>
      <TeacherDetails
        leader={leader}
        activity={activity}
        onClickViewReviews={onClickViewReviews}
        credentialsRef={credentialsRef}
        gradientStyles={gradientFadeStyle}
      />
    </Box>
  );
}
